import { useState } from "react";
import Sidebar from "../../sidebar/sidebar";
import Header from "../../header/header";
import { ViewToggle } from "./components/ViewToggle";
import { ComparisonView } from "./components/ComparisonView";
import { useScopeRefData } from "../common/hooks/useScopeRefData";
import { getLatestFY } from "../../DataManagment/Quantative/component/answerHistoryPage/components/utils";

/**
 * Standalone comparison page for a carbon-footprint scope. Reuses the shared
 * Sidebar + Header chrome (unmodified) and renders the overlaid ComparisonView.
 * Kept separate from the KPI list (QuantativeList) so the shared list is not
 * touched.
 * @param {string} props.scopeKey - API scope key, e.g. "scope 1"
 * @param {string} props.title - page heading
 * @param {string} props.viewMode
 * @param {(mode:string)=>void} props.onViewChange
 * @param {string} props.routePath - current pathname for the sidebar
 */
const ComparisonPage = ({ scopeKey, title, viewMode, onViewChange, routePath }) => {
  const { financialYears, locations } = useScopeRefData();
  const [sidebarExpanded, setSidebarExpanded] = useState(true);

  const baseFy = getLatestFY(financialYears) || financialYears[0];

  return (
    <div style={{ display: "flex", height: "100vh", overflow: "hidden", background: "var(--bg, #f1f5f9)" }}>
      <div
        style={{
          flex: sidebarExpanded ? "0 0 21%" : "0 0 60px",
          position: "sticky",
          top: 0,
          height: "100vh",
          background: "var(--surface)",
          borderRight: "1px solid var(--rule)",
          zIndex: 100,
          transition: "flex 0.2s ease",
        }}
      >
        <Sidebar dataFromParent={routePath} onSidebarToggle={setSidebarExpanded} />
      </div>

      <main style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "auto", minWidth: 0 }}>
        <Header />

        <div style={{ padding: "16px 24px 40px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12, marginBottom: 16 }}>
            <div>
              <h2 style={{ fontSize: 20, fontWeight: 800, margin: 0, color: "var(--ink, #1e293b)", letterSpacing: "-0.02em" }}>{title}</h2>
              <span style={{ fontSize: 12, color: "var(--ink-4, #94a3b8)" }}>Comparison</span>
            </div>
            <ViewToggle viewMode={viewMode} onChange={onViewChange} />
          </div>

          <ComparisonView
            scopeKey={scopeKey}
            selectedFY={baseFy}
            financialYears={financialYears}
            locations={locations}
          />
        </div>
      </main>
    </div>
  );
};

export default ComparisonPage;
